
/**
 * GiveWP functionality
 */


/* global $biro_body  */
var $biro_givewp_recurring;
var $biro_givewp_recurring_period;


// On page load
jQuery( function( $ ) {

	// Init
	var $gfw = $( '.give-form-wrap' );

	if ( $biro_body.hasClass( 'give-recurring' ) ) {

		// Init
		$biro_givewp_recurring        = $( '.give-recurring-donors-choice' );
		$biro_givewp_recurring_period = $( '#give-recurring-modal-period' );
		biro_givewp_gateway_changed( $( 'input[type="radio"].give-gateway:checked' ).val() );

		// Gateway changed?
		$biro_body.on( 'change', 'input[type="radio"].give-gateway', function() {

			biro_givewp_gateway_changed( $( this ).val() )

		});

	}

	if ( $gfw.length ) {

		// Hack to make tooltips keyboard-accessible
		$gfw.find( '.give-tooltip' ).each( function( i ) {
			$( this ).attr( 'tabindex', 0 );
		});
		$gfw.on( 'focus', '.give-tooltip', function( e ) {
			$( this ).addClass( 'focus' );
		}).on( 'blur', '.give-tooltip', function( e ) {
			$( this ).removeClass( 'focus' );
		});

	}

});


/**
 * Perform actions after the gateway has been changed
 *
 * @param {string} gateway
 *
 * @return {void}
 */
function biro_givewp_gateway_changed( gateway ) {

	// Recurring donations
	if ( gateway === 'gocardless' ) {

		// Show for GoCardless
		$biro_givewp_recurring.slideDown();
		$biro_givewp_recurring.find( 'input[name="give-recurring-period"]' ).prop( 'checked', true ).trigger( 'change' );

	} else {

		// Hide for everything else
		$biro_givewp_recurring.find( 'input[name="give-recurring-period"]' ).prop( 'checked', false ).trigger( 'change' );
		$biro_givewp_recurring.slideUp();
		$biro_givewp_recurring_period.text( '' );

	}

}